import AlternativeParentsCategory from './AlternativeParentsCategory';

export default AlternativeParentsCategory;